<template>
    <div :style="style" :class="classes" v-on="$listeners"/>
</template>
<script>
export default {
    name: 'Overlay',
    props: {
        image: {
            type: String,
            default: '',
        },
        dimmed: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes () {
            return {
                overlay: true,
                dimmed: this.dimmed,
                image: !!this.image,
            };
        },
        style () {
            return this.image ? {
                backgroundImage: `url("${this.image}")`,
            } : {};
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.overlay {
    @include cover();
    position: absolute;
    background-color: rgba($black, .2);
    box-shadow: inset 0 0 20px 0 rgba($black, .2);
    z-index: -1;

    &.image {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    &.dimmed {
        filter: brightness(.6);
    }
}
</style>
